import React from "react";
import Modal from "react-modal";
import { XCircle, Archive, Loader2 } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const ConfirmArchiveModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
  const { darkMode } = useTheme();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={`p-8 rounded-2xl w-[420px] mx-auto mt-40 outline-none border transition-all duration-300 shadow-xl
        ${darkMode
          ? "bg-gradient-to-b from-gray-900 to-gray-950 text-gray-100 border-gray-800 shadow-[0_0_25px_rgba(0,0,0,0.5)]"
          : "bg-gradient-to-b from-white to-gray-50 text-gray-900 border-gray-300 shadow-[0_0_25px_rgba(0,0,0,0.15)]"}
      `}
      overlayClassName={`fixed inset-0 flex justify-center items-start z-50 backdrop-blur-sm transition-colors duration-300
        ${darkMode ? "bg-black/70" : "bg-gray-900/40"}`}
    >
      <div className="flex flex-col items-center text-center">
        <Archive
          className={`w-12 h-12 mb-3 ${
            darkMode ? "text-red-400" : "text-red-600"
          }`}
        />
        <h2
          className={`text-xl font-semibold mb-2 ${
            darkMode ? "text-gray-100" : "text-gray-800"
          }`}
        >
          Arhivați acest task?
        </h2>
        <p
          className={`text-sm mb-6 ${
            darkMode ? "text-gray-400" : "text-gray-600"
          }`}
        >
          Task-ul arhivat va fi eliminat din lista curentă. <br />
          Această acțiune nu poate fi anulată.
        </p>

        <div className="flex justify-center gap-4 mt-2">
          <button
            onClick={onClose}
            disabled={loading}
            className={`px-5 py-2.5 rounded-lg font-medium text-sm transition ${
              darkMode
                ? "bg-gray-700 hover:bg-gray-600 text-gray-100"
                : "bg-gray-200 hover:bg-gray-300 text-gray-800"
            }`}
          >
            Anulează
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm transition
              ${darkMode
                ? "bg-red-700 hover:bg-red-600 text-white"
                : "bg-red-600 hover:bg-red-700 text-white"}
            `}
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" /> Se arhivează...
              </>
            ) : (
              <>
                <XCircle className="w-4 h-4" /> Arhivează
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmArchiveModal;
